<template>
  <div v-if="currentUser" class="visits-container">
    <div class="page-header">
      <h1>Moje wizyty</h1>
      <VisitsFilters @getVisits="getVisits" :visits="visits" :visible-visits-type="visibleVisitsType" />
    </div>
    <div class="visits-layout">
      <div class="visits-list-section">
        <SectionCard>
          <template #header>
            Lista wizyt
          </template>
          <ServiceModal :no-schedule-btn="true"/>
          <div class="visits-list" v-if="visits[visibleVisitsType].items.length > 0">
            <div>
              <VisitCard
                v-for="item in visits[visibleVisitsType].items"
                :key="item.id"
                :item="item"
                :pets="pets"
                :areVisitsClosed="areVisitsClosed"
                @cancelVisit="() => cancelVisit(item.id)"
              />
            </div>
          </div>
          <div v-else class="empty-state">
            <p>Brak dostępnych wizyt.</p>
          </div>
        </SectionCard>
      </div>
    </div>
  </div>
  <div v-else>
    <h4>Ładowanie...</h4>
  </div>
</template>
  
<script>
import { useMeta } from 'vue-meta';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import SectionCard from "@/components/Cards/SectionCard.vue";
import VisitCard from "@/components/Cards/VisitCard.vue";
import VisitsFilters from "@/components/SpecialComponents/VisitsFilters.vue";

export default{
  name:'VisitsVue',
  setup () {
    useMeta({ title: 'Moje wizyty' });
    
    return {
        authStore: useAuthStore(),
        appStore: useAppStore(),
    }
  },
  data(){
    return{
      dates:[],
      items: [],
      areVisitsClosed: false,
      pets: [],
      visits: {
        open: {
          items: [],
          pagination: {
            currentPage: 1,
            perPage: 15,
            lastPage: 1,
            total: 0
          }
        },
        closed: {
          items: [],
          pagination: {
            currentPage: 1,
            perPage: 15,
            lastPage: 1,
            total: 0
          }
        },
        completed: {
          items: [],
          pagination: {
            currentPage: 1,
            perPage: 15,
            lastPage: 1,
            total: 0
          }
        },
        canceled: {
          items: [],
          pagination: {
            currentPage: 1,
            perPage: 15,
            lastPage: 1,
            total: 0
          }
        }
      },
      visibleVisitsType: 'open',
    }
  },
  computed: {
    currentUser() {
        return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }
    this.getVisits()
    this.getPets()
  },
  methods:{
    getPets(){
      axios.get(`/User/${this.currentUser.id}`).then(res => {
        this.pets = res.data.pets
      })
    },
    getVisits (page = 1, status = 'open') {
      this.isLoading = true;

      axios.get(`/CalendarItemsForUser/${status}`, {
        params: {
          page: page
        }
      }).then(res => {
        this.visits[status].items = res.data.data;

        this.visits[status].pagination.currentPage = res.data.current_page || page;
        this.visits[status].pagination.perPage = res.data.per_page || this.visits[status].pagination.perPage;
        this.visits[status].pagination.lastPage = res.data.last_page || 1;
        this.visits[status].pagination.total = res.data.total || this.visits[status].items.length;

        this.visibleVisitsType = status;
      }).catch(() => {
        this.appStore.setIsAlert('Nie udało się pobrać listy wizyt.');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    cancelVisit(id){
      axios.post('/CalendarItemRemoveUser', {
        calendar_id: id,
        user_id: this.currentUser.id,
        employee_id: 0
      }, authHeader()).then(res => {
        if(String(res.status).charAt(0) === '2'){
          this.appStore.setIsSuccess('Anulowano wizytę')
          this.dates = []
          this.items = []
          this.getVisits()
        }
      }).catch(() => {

      })
    }
  },
  components:{
    VisitsFilters,
    VisitCard,
    SectionCard,
    ServiceModal
  }
}
</script>
  
<style scoped lang='scss'>
.paid{
  color: #77B43F;
}
.not-paid{
  color: #BB2D3B;
}
.payment-error{
  color: #F2790F;
}
.visits-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}
.visits-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}
.visits-list-section {
  flex: 1 1 0;
  min-width: 0;
}
.visit-filter-buttons{
  display: flex;
  gap: 12px;
}
.visits-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.closed{
  border: 1px solid #10b981;
}
.open{
  border: 1px solid #f97316;
}
.empty-state {
  text-align: center;
  padding: 32px;
  color: #9ca3af;
  font-size: 1.5rem;
}
</style>